import type { TargetingType } from "@adpilot/shared";
import { useTranslation } from "react-i18next";

interface CampaignTargetingTypeCellProps {
  targetingType: TargetingType | null;
}

export function CampaignTargetingTypeCell({ targetingType }: CampaignTargetingTypeCellProps) {
  const { t } = useTranslation("campaign");

  return (
    <span className="text-ink">
      {targetingType ? t(`list.targetingType.${targetingType}`) : "—"}
    </span>
  );
}
